export const APPLICATION_BY_ID = (id: string) => `query {
    application(applicationId: "${id}"){ 
    ... on ApplicationOutput {
        id
        email
        additionalInsuredRoommates {
          email
        }
        buildingId
        communityId
        buildingUnit
        companyProductCd
        phone
        status
        coverageStart
        coverageEnd
        firstName
        medicalPayments
        personalLiabilityCoverage
        personalPropertyCoverage
        theft 
        deductible
        lastName
        paymentPlans {
          downPaymentAmount
          installmentAmount
          installmentFeeAmount
          installmentPaymentAmount
          paymentPlanCd
          totalPremiumAmt
        }
        installment  {
          dueDt
          feeAmount
          paymentAmount
          premiumAmount
        }
    }
    ... on ErrorListOutput {
        errors: errors {
            type
            message
        }
        }
    }
  }
  `;
